module.exports = __webpack_public_path__ + "assets/img/sdwan-module7-1.b1ac8744.png";